var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[(_vm.user)?_c('div',[_c('el-row',[_c('user-card',{attrs:{"user":_vm.user}})],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }